import React, { useMemo } from "react";
import ServiceFormsSection from "../Shared/ServiceFormsSection";

const AgentServiceFormsSection = ({ model }) => {
    const serviceForms = model?.serviceForms || [];

    const categories = useMemo(() => {
        const unique = new Map();
        serviceForms.forEach(f => {
            if (!unique.has(f.categoryID)) {
                unique.set(f.categoryID, {
                    id: f.categoryID,
                    name: f.categoryName
                });
            }
        });
        return Array.from(unique.values());
    }, [serviceForms]);

    return (
        <ServiceFormsSection
            categories={categories}
            forms={serviceForms}
            onCategorySelect={(cat) => console.log("Agent selected category:", cat)}
            onFormSelect={(form) => console.log("Agent selected form:", form)}
        />
    );
};

export default AgentServiceFormsSection;
